import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PurchaseButton } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../utilityClasses.module.scss'
import { ModalTrigger } from '../../utils/ModalTrigger'
import { MoreWaysToSubscribeModal } from './moreWaysToWatchModal'

type IMoreSubscriptionOptions = {
  svodWinners: WpsRuntime.atv.wps.SubscribeActionTreeRightProps
  titleId?: string
  forceDoubleHeight: boolean
} & ReturnType<typeof mapStateToProps>

const CSRMoreSubscriptionOptionsButton = ({
  svodWinners,
  forceDoubleHeight
}: IMoreSubscriptionOptions) => {

  const label = svodWinners.metadata && svodWinners.metadata.label

  return (
    <ModalTrigger
      modalId='dvui-close-overlay-mwts'
      modalContent={<MoreWaysToSubscribeModal svodWinners={svodWinners} />}
      toggle={
        ({ openModalClickHandler }) => (
          <PurchaseButton
            data-ux-click
            onClick={openModalClickHandler}
            className={`${utilityClasses.fullWidthPhablet} more-subscription-options-button`}
            forceDoubleHeight={forceDoubleHeight}
          >
            <Text string={label} />
          </PurchaseButton>
        )
      } />

  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  requestContext: sanitizedRequestContextSelector(state),
})

export const MoreSubscriptionOptionsButton = connect(mapStateToProps)(
  CSRMoreSubscriptionOptionsButton
)
